// import Vue from 'vue'
import Router from 'vue-router'
import Account from './account'
import Other from './other'
import Resource from './resource'
export default new Router({
  // mode: 'history',
  routes: [
    Account,
    Other,
    Resource,
    // { path: '*', redirect: '/resource' }, /*默认跳转路由*/
  ]
})

Vue.use(Router);



// WEBPACK FOOTER //
// ./src/pages/pc/router/index.js